import { render } from "./HistoryView.vue?vue&type=template&id=a1d12542"
import script from "./HistoryView.vue?vue&type=script&lang=js"
export * from "./HistoryView.vue?vue&type=script&lang=js"

import "./HistoryView.vue?vue&type=style&index=0&id=a1d12542&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/view/HistoryView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a1d12542"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a1d12542', __exports__)) {
    api.reload('a1d12542', __exports__)
  }
  
  module.hot.accept("./HistoryView.vue?vue&type=template&id=a1d12542", () => {
    api.rerender('a1d12542', render)
  })

}


export default __exports__